import { Dispatch } from 'redux';
import { connect } from 'react-redux';
import { DispatchProps, OwnProps, StateProps } from './CaseEditScreen';
import CaseEdit from './CaseEditScreen';
import { StoreState } from 'src/store/reducers';
import { getCase, deleteFileCase, getFiles, createFilesCase } from 'src/store/actions/case-actions';
import { formValueSelector, getFormValues } from 'redux-form';
import CaseEnum from 'src/enumerables/case-enum';
import { getValFromEnum } from 'src/components/redux-form/utils/dropdown-values';
import { QueryParams } from 'src/types/grid';
import { getOrders } from 'src/store/actions/order-actions';
import { getServiceTypes } from 'src/store/actions/service-type-actions';
import { getServiceLocations } from 'src/store/actions/service-location-actions';
import { getProvidersSmall } from 'src/store/actions/provider-actions';
import { getStudentsSmall } from 'src/store/actions/student-actions';
import { toast } from 'react-toastify';
import { getVendorsSmall } from 'src/store/actions/vendor-actions';
import { getDistrictsSmall } from 'src/store/actions/district-actions';
import { selectNameStudents } from '../../../../../../store/selectors/students-selectors';
import { selectNameDistricts } from '../../../../../../store/selectors/districts-selectors';
import { selectNameVendors } from '../../../../../../store/selectors/vendors-selectors';
import OrderEnum from '../../../../../../enumerables/order-enum';

function mapStateToProps(state: StoreState, ownProps: OwnProps): StateProps {
    const selector = formValueSelector('case-form');
    const caseType = selector(state, 'caseTypeDropDown');
    const statusItem = selector(state, 'caseStatusDropdown');
    const serviceTypeProvider = selector(state, 'serviceTypeProviderDropDown');
    const invoiceSigner = selector(state, 'invoiceSignerDropDown');
    const caseEnum = CaseEnum ? CaseEnum.getEnum('caseType') : {};
    const caseTypes: SelectObject[] = getValFromEnum(caseEnum);
    const orderType = selector(state, 'orderTypeDropDown');
    const caseTypeValue: string | number = caseType ? caseType.value : caseTypes ? caseTypes[0].value : 1;
    const typeEnum = CaseEnum ? CaseEnum.getEnum(`OrderType_${caseTypeValue}`) : {};
    const orderTypes: SelectObject[] = getValFromEnum(typeEnum);

    const serviceTypeProviderEnum = OrderEnum ? OrderEnum.getEnum('ServiceTypeProvider') : {};
    const serviceTypeProviders: SelectObject[] = getValFromEnum(serviceTypeProviderEnum);

    const orderTypeValue: string | number = orderType ? orderType.value : orderTypes ? orderTypes[0].value : 1;

    const invoiceSignerValue: string | number = invoiceSigner ? invoiceSigner.value : undefined;

    const statusEnums = CaseEnum ? CaseEnum.getEnum('CaseStatus') : {};
    const statusItems: SelectObject[] = getValFromEnum(statusEnums);

    const statusItemValue: string | number = statusItem ? statusItem.value : statusItems ? statusItems[0].value : 1;

    const serviceTypeProviderValue: string = serviceTypeProvider ? serviceTypeProvider.value : (serviceTypeProviders ? serviceTypeProviders[0].value : 1);

    const orders = selector(state, 'ordersDropDown');
    const orderValue = orders ? orders.value : undefined;

    return {
        caseTypeValue,
        orderTypes,
        caseTypes,
        orderTypeValue,
        statusItemValue,
        orderValue,
        invoiceSignerValue,
        serviceTypeProviderValue,
        serviceTypeProviders,
        orders: state.orders.data,
        providers: state.providers.data,
        students: selectNameStudents(state),
        districts: selectNameDistricts(state),
        vendors: selectNameVendors(state),
        serviceTypes: state.serviceTypes.data,
        serviceLocations: state.serviceLocations.data,
        valuesForm: getFormValues('case-form')(state),
        caseEnt: state.cases.current,
        files: state.cases.currentFiles,
        inProgress: state.cases.inProgress,
        inProgressProvider: state.providers.inProgress,
        isDouble: state.cases.isDouble,
    };
}

function mapDispatchToProps(dispatch: Dispatch, ownProps: OwnProps): DispatchProps {
    return {
        getData: (id) => dispatch(getCase(id)),
        getFiles: (id) => dispatch(getFiles(id)),
        addFiles: (id, files) =>
            dispatch(
                createFilesCase(
                    id,
                    files,
                    () => toast.success('File added successfully'),
                    (errorMessage: string) => {
                        toast.error(errorMessage);
                    },
                ),
            ),
        removeFile: (id) => dispatch(deleteFileCase(id)),
        getOrders: (params: QueryParams) => dispatch(getOrders(params)),
        getServiceTypes: (params: QueryParams) => dispatch(getServiceTypes(params)),
        getServiceLocations: (params: QueryParams) => dispatch(getServiceLocations(params)),
        getProviders: (params: QueryParams) => dispatch(getProvidersSmall(params)),
        getStudents: (params: QueryParams) => dispatch(getStudentsSmall(params)),
        getVendors: (params: QueryParams) => dispatch(getVendorsSmall(params)),
        getDistricts: (params: QueryParams) => dispatch(getDistrictsSmall(params)),
    };
}

const CaseEditScreen = connect<StateProps, DispatchProps, OwnProps, StoreState>(
    mapStateToProps,
    mapDispatchToProps,
)(CaseEdit);

export default CaseEditScreen;
